import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { LucideAngularModule, X, AlertTriangle } from 'lucide-angular';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './confirm-modal.html',
  styleUrl: './confirm-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmModalComponent {
  private readonly isOpen$$ = new BehaviorSubject<boolean>(false);
  protected readonly isOpen$ = this.isOpen$$.asObservable();

  private readonly title$$ = new BehaviorSubject<string>('Confirm');
  protected readonly title$ = this.title$$.asObservable();

  private readonly message$$ = new BehaviorSubject<string>('Are you sure?');
  protected readonly message$ = this.message$$.asObservable();

  private readonly confirmText$$ = new BehaviorSubject<string>('Confirm');
  protected readonly confirmText$ = this.confirmText$$.asObservable();

  private readonly cancelText$$ = new BehaviorSubject<string>('Cancel');
  protected readonly cancelText$ = this.cancelText$$.asObservable();

  private readonly confirmColor$$ = new BehaviorSubject<string>('#ef4444');
  protected readonly confirmColor$ = this.confirmColor$$.asObservable();

  @Input()
  set isOpen(value: boolean) {
    this.isOpen$$.next(value);
  }

  @Input()
  set title(value: string) {
    this.title$$.next(value);
  }

  @Input()
  set message(value: string) {
    this.message$$.next(value);
  }

  @Input()
  set confirmText(value: string) {
    this.confirmText$$.next(value);
  }

  @Input()
  set cancelText(value: string) {
    this.cancelText$$.next(value);
  }

  @Input()
  set confirmColor(value: string) {
    this.confirmColor$$.next(value);
  }

  @Output() readonly confirmed = new EventEmitter<void>();
  @Output() readonly cancelled = new EventEmitter<void>();

  protected readonly icons = {
    X,
    AlertTriangle,
  };

  protected onConfirm(): void {
    this.confirmed.emit();
  }

  protected onCancel(): void {
    this.cancelled.emit();
  }
}
